module.exports = __webpack_public_path__ + "0.1.0/img/manage.e79e8834.png";